<template>
  <main class="login">
    <v-toolbar class="indigo" dark fixed app>
      <v-toolbar-side-icon @click.stop="$root.$children[0]._data.drawer = !$root.$children[0]._data.drawer"></v-toolbar-side-icon>
      <v-toolbar-title>Staging platform</v-toolbar-title>
    </v-toolbar>
    <v-content>
      <v-container fluid fill-height>
        <v-layout justify-center align-center>
          <v-flex xs12 xl4 lg6 sm8>
            <v-card class="elevation-8">
              <v-card-title>
                <v-flex xs12 align-end flexbox>
                  <img src="https://ssl.gstatic.com/images/branding/product/1x/avatar_circle_blue_512dp.png" style="height: 40px; margin-right: 20px">
                  <span class="title" style="padding: 10px 0">Melden Sie sich an, um fortzufahren</span>
                </v-flex>
              </v-card-title>
              <v-card-text style="padding-top: 0">
                <div>
                  <span class="body-2 grey--text">Anmelden als...</span><br>
                  <v-list two-line>
                    <template v-for="user in users">
                      <v-divider v-if="user.divider" :inset="user.inset"></v-divider>
                      <v-list-tile avatar v-else :key="user.title" @click="login(user.userId)">
                        <v-list-tile-avatar>
                          <img :src="user.avatar"></v-list-tile-avatar>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title>{{ user.fullname }}</v-list-tile-title>
                          <v-list-tile-sub-title>
                            <span class='grey--text text--darken-2'>{{ user.email }}</span>
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </template>
                  </v-list>
                  <a href="#">Mit einem anderen Konto anmelden</a>
                </div>
              </v-card-text>
            </v-card>
            <v-spacer></v-spacer>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </main>
</template>

<script>
export default {
  computed: {
    users () {
      return this.$store.getters.getUsers
    }
  },
  data () {
    return {}
  },
  methods: {
    login (userId) {
      this.$store.dispatch('loginUser', userId).then(() => {
        this.$router.push('/dashboard')
      })
    }
  }
}
</script>

<style>
.login {
  background-color: #ccc
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue